import { render, staticRenderFns } from "./LeadersCircle.vue?vue&type=template&id=797f112d&scoped=true&"
import script from "./LeadersCircle.vue?vue&type=script&lang=js&"
export * from "./LeadersCircle.vue?vue&type=script&lang=js&"
import style0 from "./LeadersCircle.vue?vue&type=style&index=0&id=797f112d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797f112d",
  null
  
)

export default component.exports